import { render, staticRenderFns } from "./IndiceDaAtualizacao.vue?vue&type=template&id=36fb998c&"
import script from "./IndiceDaAtualizacao.vue?vue&type=script&lang=ts&"
export * from "./IndiceDaAtualizacao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports